export type AppErrorCode =
  | 'network'
  | 'unauthorized'
  | 'forbidden'
  | 'not_found'
  | 'validation'
  | 'conflict'
  | 'server'
  | 'api_error'
  | 'unknown';

export interface AppError {
  code: AppErrorCode;
  message: string;
  details?: unknown;
  timestamp: Date;
}

export function createAppError(
  code: AppErrorCode,
  message: string,
  details?: unknown
): AppError {
  return {
    code,
    message,
    details,
    timestamp: new Date(),
  };
}

export function isAppError(error: unknown): error is AppError {
  return (
    typeof error === 'object' &&
    error !== null &&
    'code' in error &&
    'message' in error &&
    'timestamp' in error
  );
}
